// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as SendSmsRepoManager from "./SendSmsRepoManager.bs.js";

function fetchSmsUser(param, country, onSuccess, onFailure) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchSMSUser, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchSmsList(param, country, onSuccess, onFailure) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.fetchSMSList, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function fetchSmsTemplateList(country, onSuccess, onFailure) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(RepoInstance.fetchSMSTemplateList, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function sendSmsMessage(param, onSuccess, onFailure, country) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.sendSMSMessage, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function resendSmsMessage(param, country, onSuccess, onFailure) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.resendSMSMessage, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function createSmsTemplate(param, country, onSuccess, onFailure) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.createSMSTemplate, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

function deleteSmsTemplate(param, country, onSuccess, onFailure) {
  var RepoInstance = SendSmsRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param$1) {
                return Curry._2(RepoInstance.deleteSMSTemplate, param, country);
              }), Curry.__1(onSuccess), Curry.__1(onFailure));
}

export {
  fetchSmsUser ,
  fetchSmsList ,
  fetchSmsTemplateList ,
  sendSmsMessage ,
  resendSmsMessage ,
  createSmsTemplate ,
  deleteSmsTemplate ,
  
}
/* SendSmsRepoManager Not a pure module */
